import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Home, Search, ArrowLeft } from 'lucide-react';
import { PremiumHeader } from '@/components/premium/PremiumHeader';
import { PremiumFooter } from '@/components/premium/PremiumFooter';
import { SEO } from '@/components/SEO';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: 'Manrope, sans-serif' }}>
      <SEO title="Page Not Found | Modular Furniture Store" description="The page you're looking for doesn't exist. Browse our collection of modular office furniture." noindex={true} />
      <PremiumHeader />
      <div className="container mx-auto px-4 py-24 sm:py-32 text-center max-w-2xl">
        <h1 className="text-7xl sm:text-8xl font-extrabold text-[#c5a059] mb-4">404</h1>
        <h2 className="text-xl sm:text-2xl font-bold text-[#1a1a1a] mb-4">Page Not Found</h2>
        <p className="text-gray-500 text-sm sm:text-base mb-10 leading-relaxed">
          The page you're looking for doesn't exist or has been moved. Let us help you find what you need.
        </p>
        <div className="flex flex-wrap justify-center gap-3">
          <Link to="/">
            <Button className="bg-[#c5a059] hover:bg-[#b8934d] text-white rounded-none px-6 py-4 text-xs tracking-[0.15em] font-bold">
              <Home className="w-4 h-4 mr-2" /> GO HOME
            </Button>
          </Link>
          <Link to="/products">
            <Button variant="outline" className="border-2 border-[#1a1a1a] text-[#1a1a1a] hover:bg-[#1a1a1a] hover:text-white rounded-none px-6 py-4 text-xs tracking-[0.15em] font-bold bg-transparent">
              <Search className="w-4 h-4 mr-2" /> BROWSE PRODUCTS
            </Button>
          </Link>
        </div>
        <div className="mt-16 border-t border-gray-100 pt-10">
          <p className="text-xs text-gray-400 uppercase tracking-[0.2em] mb-4">Popular Categories</p>
          <div className="flex flex-wrap justify-center gap-3">
            <Link to="/products?category=Modular+Office+Workstation" className="text-sm text-[#1a1a1a] hover:text-[#c5a059] font-medium transition-colors">Workstations</Link>
            <span className="text-gray-300">|</span>
            <Link to="/products?category=Privacy+Booths" className="text-sm text-[#1a1a1a] hover:text-[#c5a059] font-medium transition-colors">Privacy Booths</Link>
            <span className="text-gray-300">|</span>
            <Link to="/products?category=Storage+Cabinets" className="text-sm text-[#1a1a1a] hover:text-[#c5a059] font-medium transition-colors">Storage Cabinets</Link>
            <span className="text-gray-300">|</span>
            <Link to="/blog" className="text-sm text-[#1a1a1a] hover:text-[#c5a059] font-medium transition-colors">Blog</Link>
            <span className="text-gray-300">|</span>
            <Link to="/contact" className="text-sm text-[#1a1a1a] hover:text-[#c5a059] font-medium transition-colors">Contact</Link>
          </div>
        </div>
      </div>
      <PremiumFooter />
    </div>
  );
}
